import apiService from "./globalService"

export const BiographyService = ()=> {

    return {
        getPage: (slug: string) => {
            return apiService.get(`/wp-json/wp/v2/pages?slug=${slug}`);
        }
    }   
}
